import { render } from "./BaseWarning.vue?vue&type=template&id=04f35802"
import script from "./BaseWarning.vue?vue&type=script&lang=ts"
export * from "./BaseWarning.vue?vue&type=script&lang=ts"

import "./BaseWarning.vue?vue&type=style&index=0&id=04f35802&lang=scss"
script.render = render

export default script